// client/src/pages/Blog.js
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import blogs from "../data/blogs";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay },
});

export default function Blog() {
  return (
    <div className="min-h-screen bg-[#05040f] text-white px-6 md:px-20 py-16">
      <motion.div
        {...fadeUp(0.05)}
        className="max-w-4xl mx-auto text-center mb-12"
      >
        <Link to="/" className="inline-flex items-center justify-center gap-3">
          <img src="/logo.png" alt="smsorbit" className="w-10 h-10 rounded-xl" />
          <span className="text-xl font-bold tracking-wide">SMSOrbit</span>
        </Link>
        <h1 className="mt-6 text-3xl md:text-4xl font-bold">
          SMSOrbit <span className="text-purple-400">Blogs</span>
        </h1>
        <p className="mt-3 text-gray-400 text-sm md:text-base">
          News, updates and announcements for agencies, resellers and power
          users.
        </p>
      </motion.div>

      <motion.div
        {...fadeUp(0.1)}
        className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8"
      >
        {blogs.map((post, idx) => (
          <motion.div
            key={post.slug}
            whileHover={{ y: -6, scale: 1.02 }}
            className="rounded-3xl bg-[#090912] border border-white/10 overflow-hidden flex flex-col"
          >
            {/* “Image” block – gradient header */}
            <div className="h-40 bg-gradient-to-br from-purple-600 via-blue-600 to-indigo-700 flex items-center justify-center">
              <span className="text-5xl font-bold text-white/90">
                {idx + 1}
              </span>
            </div>

            <div className="p-6 flex-1 flex flex-col">
              <div className="text-xs uppercase tracking-wide text-purple-300 mb-1">
                {post.category}
              </div>
              <h2 className="text-lg font-semibold mb-2">{post.title}</h2>
              <p className="text-sm text-gray-300 flex-1">{post.short}</p>
              <Link
                to={`/blogs/${post.slug}`}
                className="mt-4 inline-flex items-center justify-center px-4 py-2 rounded-xl bg-purple-600 hover:bg-purple-700 text-sm font-semibold"
              >
                Read more
              </Link>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
